import "./App.css";
import React, { useState, useEffect } from "react";

import Menu from "./components/Navbar/Menu";
import MainPage from "./components/MainPage";
import Education from "./components/Education/Education";
import Skills from "./components/Skills";
import Projects from "./components/Projects/Projects";
import WorkExperience from "./components/WorkExperience/WorkExperience";
import AboutMe from "./components/AboutMe";
import ContactMe from "./components/ContactMe";

import Footer from "./components/Footer";
//import ParticlesBG from "./components/Particles";
import JarvisCircle from "./components/JarvisCircle";
import Ironman from "./components/Ironman";

import Thanos from "./components/ThanosSnap/ThanosSnap";

import { AppProvider } from "./components/Context.js";

import "./CSS/Fonts.css";
import WandaMagic2 from "./Assets/WandaMagic2.png";
function App() {
  const [loading, setLoading] = useState(true);
  const [onLoadState, setOnLoadState] = useState(false);

  function myFunction() {
    setOnLoadState(true);
    console.log("Loaded!!");
  }

  document.body.style.overflow = "hidden";

  useEffect(() => {
    new Image().src = WandaMagic2;

    setTimeout(() => {
      if (onLoadState) {
        setLoading(false);
        document.body.style.removeProperty("overflow");
      }
    }, 2000);

    window.onload = () => myFunction();
  }, [onLoadState]);

  return (
    <>
      <AppProvider>
        <React.Fragment>
          {loading ? <Ironman /> : null}
          <div
            className="App"
            style={loading ? { visibility: "hidden" } : null}
          >
            <JarvisCircle />

            <Menu />

            <Thanos />

            <MainPage id="MainPage" />
            <Education id="Education" />
            <Skills id="Skills" />
            <Projects id="Projects" />
            <WorkExperience id="WorkExperience" />
            <AboutMe id="AboutMe" />
            <ContactMe id="ContactMe" />
            <Footer />
          </div>
        </React.Fragment>
      </AppProvider>
    </>
  );
}

export default App;
